import { useTranslation } from "react-i18next";

const SettingsTableRangePagination = ({
  totalEntry,
  recordPerPage = 10,
  currentPage,
  onPageChange,
  /** Dans un pied `.table-standard-bottom` (carte tableau avec bordure) */
  variant = "standalone",
}) => {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(totalEntry / recordPerPage) || 1);
  const start = totalEntry === 0 ? 0 : (currentPage - 1) * recordPerPage + 1;
  const end = Math.min(currentPage * recordPerPage, totalEntry);
  const label = totalEntry === 0 ? "0 - 0" : `${start} - ${end}`;

  const rootClass =
    variant === "footer"
      ? "settings-table-range-pagination settings-table-range-pagination--footer"
      : "settings-table-range-pagination";

  return (
    <nav className={rootClass} aria-label="Pagination">
      <button
        type="button"
        className="settings-table-range-pagination__btn"
        disabled={currentPage <= 1 || totalEntry === 0}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label={t("Previous")}
      >
        <i className="fas fa-chevron-left" aria-hidden />
      </button>
      <span className="settings-table-range-pagination__label">{label}</span>
      <button
        type="button"
        className="settings-table-range-pagination__btn"
        disabled={currentPage >= totalPages || totalEntry === 0}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label={t("Next")}
      >
        <i className="fas fa-chevron-right" aria-hidden />
      </button>
    </nav>
  );
};

export default SettingsTableRangePagination;
